module.exports = __webpack_public_path__ + "fonts/emj_skolkovo.76fd15f.ttf";